import { COEFFICIENT_KB, FILE_ERRORS, MAX_KB } from "../constants";
export var getSizeWithUnits = function getSizeWithUnits(fileSize) {
  var numberOfDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var size = '';
  if (fileSize < MAX_KB) {
    size = "".concat((fileSize / COEFFICIENT_KB).toFixed(numberOfDecimals), " \u041A\u0431");
  } else {
    size = "".concat((fileSize / MAX_KB).toFixed(numberOfDecimals), " \u041C\u0431");
  }
  return size;
};
// проверяем чтобы имя файла заканчивалось на расширение из пула allowedTypes
var isTypeValid = function isTypeValid(fileName, allowedTypes) {
  return allowedTypes.some(function (type) {
    return fileName.endsWith(type);
  });
};
var isSizeValid = function isSizeValid(fileSize, maxSize) {
  return fileSize < maxSize;
};
export var checkFiles = function checkFiles(files, remainingLength, allowedTypes, maxFileSize) {
  var newFiles = Array.from(files);
  newFiles.length = remainingLength;
  var checkedFiles = [];
  newFiles.forEach(function (file) {
    if (!isSizeValid(file.size, maxFileSize)) {
      checkedFiles.push({
        name: file.name,
        error: FILE_ERRORS.size
      });
      return;
    }
    if (!isTypeValid(file.name, allowedTypes)) {
      checkedFiles.push({
        name: file.name,
        error: FILE_ERRORS.type
      });
      return;
    }
    var size = getSizeWithUnits(file.size);
    checkedFiles.push({
      file: file,
      name: file.name,
      size: size
    });
  });
  return checkedFiles;
};